import React from 'react';
import PropTypes from 'prop-types';

import LazyLoad from '../LazyLoad';
import Footer from './index';

const propTypes = {
  domain: PropTypes.string,
  is404: PropTypes.bool,
  customSiteLinks: PropTypes.instanceOf(Array),
  fromPortal: PropTypes.bool,
};
const defaultProps = {
  domain: null,
  is404: false,
  customSiteLinks: null,
  fromPortal: false,
};
const LazyFooter = ({
  domain,
  is404,
  customSiteLinks,
  fromPortal,
}) => (
  <LazyLoad>
    {
      (visible, lazyLoadRef) => (
        <Footer 
          domain={domain}
          customSiteLinks={customSiteLinks}
          visible={visible}
          refEl={lazyLoadRef}
          is404={is404}
          fromPortal={fromPortal}
        />
      )
    }
  </LazyLoad>		
);
LazyFooter.propTypes = propTypes;
LazyFooter.defaultProps = defaultProps;
export default LazyFooter;